import { Controller } from "stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  static targets = [
    "title", "form",
    "formElementsContainer",
    "personalGrowthTemplate",
    "cultureGrowthTemplate",
    "leaderRadioButtonsTemplate",
    "leaderCheckBoxesTemplate",
    "leadershipCharacteristicsTemplate",
    "otherCheckBoxesTemplate",
    "generalElementsTemplate",
    "cultureSubgroupTemplate",
    "cultureTemplate",
    "cultureCommentsTemplate",
    "cultureVisionOnlyTemplate",
    "cultureMainOnlyTemplate",
    "comparisonTemplate",
    "documentFormatInput"
  ]

  initialize() {
    const container = document.getElementById("modal_window");
    if (container) {
      this.modal = new Modal(container)
      document.addEventListener('hide-modal', () => {
        this.modal.hide()
      })
    }
  }

  proceed({ target: { dataset: { url, title, reportType, documentFormat } } }) {
    this.formElementsContainerTarget.innerHTML = ""

    this.documentFormatInputTarget.value = documentFormat || "pdf_format";

    if (reportType === "growth" || reportType === "leadership_15_self_growth" || reportType === "leadership_15_growth") {
      const personalGrowthSelects = this.personalGrowthTemplateTarget.content.cloneNode(true);

      this.formElementsContainerTarget.appendChild(personalGrowthSelects)
    } else if (reportType === "culture_with_nps_growth") {
      const cultureGrowthSelects = this.cultureGrowthTemplateTarget.content.cloneNode(true);

      this.formElementsContainerTarget.appendChild(cultureGrowthSelects)
    } else if (reportType === "leadership_15" || reportType === "leadership_15_group") {
      const leaderCheckBoxes = this.leaderCheckBoxesTemplateTarget.content.cloneNode(true);

      this.formElementsContainerTarget.appendChild(leaderCheckBoxes)
    } else if (reportType === "leadership_characteristics") {
      const leadershipCharacteristics = this.leadershipCharacteristicsTemplateTarget.content.cloneNode(true);

      this.formElementsContainerTarget.appendChild(leadershipCharacteristics)
    } else if (reportType === "culture_subgroup" || reportType === "culture_with_nps_subgroup") {
      const tagCheckBoxes = this.cultureSubgroupTemplateTarget.content.cloneNode(true);
      this.formElementsContainerTarget.appendChild(tagCheckBoxes)
    } else if (reportType === "culture_subgroup_summary" || reportType === "executive_team") {
      const tagCheckBoxes = this.cultureTemplateTarget.content.cloneNode(true);
      this.formElementsContainerTarget.appendChild(tagCheckBoxes)
    } else if (reportType === "culture" || reportType === "culture_with_nps") {
      const otherCheckBoxes = this.cultureMainOnlyTemplateTarget.content.cloneNode(true);
      this.formElementsContainerTarget.appendChild(otherCheckBoxes)
    } else if (reportType === "culture_promo") {
      const otherCheckBoxes = this.otherCheckBoxesTemplateTarget.content.cloneNode(true);
      this.formElementsContainerTarget.appendChild(otherCheckBoxes)
    } else if (reportType === "culture_comments" || reportType === "culture_comments_ai") {
      const otherCheckBoxes = this.cultureCommentsTemplateTarget.content.cloneNode(true);
      this.formElementsContainerTarget.appendChild(otherCheckBoxes)
    } else if (reportType === "comparison") {
      this.formElementsContainerTarget.appendChild(this.comparisonTemplateTarget.content.cloneNode(true))
    } else if (reportType === "culture_vision_only") {
      const otherCheckBoxes = this.cultureVisionOnlyTemplateTarget.content.cloneNode(true);
      this.formElementsContainerTarget.appendChild(otherCheckBoxes)
    } else {
      const generalElements = this.generalElementsTemplateTarget.content.cloneNode(true);

      this.formElementsContainerTarget.appendChild(generalElements)
    }

    this.titleTarget.innerHTML = title
    this.formTarget.action = url

    // Target only the select elements within the modal container
    $(this.formElementsContainerTarget).find('.select2').select2({dropdownParent: $('.modal')})

    $(this.formElementsContainerTarget).find('.select2').on('select2:select select2:unselect', function () {
        let event = new Event('change', { bubbles: true }) // fire a native event
        this.dispatchEvent(event);
    });
  }

  selectAll({ target: { checked } }) {
    const $inputList = $(this.formTarget).find('.response-list input:not(:hidden):not(:disabled)')

    if (checked) $inputList.prop('checked', true)
    else $inputList.prop('checked', false)
  }

  checkHandler() {
    const $selectAllInput = $(this.formTarget).find('#select_all')
    const $inputList = $(this.formTarget).find('.response-list input:not(:hidden):not(:disabled)')
    const $checkedInputList = $inputList.filter(':checked')

    if ($inputList.length === $checkedInputList.length) {
      $selectAllInput.prop('checked', true).prop('indeterminate', false)
    } else if (!$checkedInputList.length) {
      $selectAllInput.prop('checked', false).prop('indeterminate', false)
    } else {
      $selectAllInput.prop('indeterminate', true)
    }
  }

  toggleExpand(event) {
    const element = $(event.currentTarget)
    element.closest('.modal-dialog').toggleClass("expanded");
  }
}
